import { render, staticRenderFns } from "./synthesize-contract-template.html?vue&type=template&id=e36b7ec8&scoped=true&external"
import script from "./synthesize-contract-template.js?vue&type=script&lang=js&external"
export * from "./synthesize-contract-template.js?vue&type=script&lang=js&external"
import style0 from "./synthesize-contract-template.scss?vue&type=style&index=0&id=e36b7ec8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36b7ec8",
  null
  
)

export default component.exports